import React, { useState } from 'react';
import { Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';

interface CreateButtonWithModalProps {
  buttonLabel?: string;
  modalTitle?: string;
  children: React.ReactNode;
  onOpen?: () => void; // optional callback on open
}

const CreateButtonWithModal: React.FC<CreateButtonWithModalProps> = ({
  buttonLabel = 'New',
  modalTitle = 'Create Item',
  children,
  onOpen
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickOpen = async () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(true);
      onOpen?.();
    }, 800); // fake loading delay
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        style={{ backgroundColor: '#272727', color: '#fff', padding: '8px 14px', fontWeight: 'bold' }}
        onClick={handleClickOpen}
        startIcon={
          loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <AddIcon />
          )
        }
        disabled={loading}
      >
        {buttonLabel}
      </Button>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <CancelIcon onClick={handleClose} className='closeModal' />
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent dividers>
          {children}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateButtonWithModal;
